import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sathwick Paladugu </span>
            from <span className="purple"> Carbondale, Illinois.</span>
            <br /> I have completed my Master's degree in Computer Science and am actively looking for Data Engineering positions. 
            <br />
            Additionally, I am currently employed as a Research Assistant at SIUC.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing 
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>

            <li className="about-activity">
              <ImPointRight /> Cooking
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a differenc and impact future. !"{" "}
          </p>
          <footer className="blockquote-footer">Sathwick Paladugu</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
